export const getVcfField = (card, field) => {
  const value = card[field];
  if (Array.isArray(value)) {
    // Si es array, toma el primer elemento con _data
    return value[0]?._data || '';
  }
  // Si es objeto, toma _data directamente
  return value?._data || '';
};

export const getPhone = (card, type = 'CELL') => {
  const tel = card.tel;
  if (Array.isArray(tel)) {
    const found = tel.find(t => t.type && t.type.includes(type));
    return found?._data || '';
  }
  if (tel && tel.type && tel.type.includes(type)) {
    return tel._data || '';
  }
  return '';
};